var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-banner"},[_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]),_c('p',{staticClass:"export"},[_vm._v(_vm._s(_vm.gettext('点击领取'))),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }